const ROLLBAR_BASE_URL =
  'https://app.rollbar.com/a/syrup-ok/fix/items?prj=348402&from=all&level=WARNING&level=CRITICAL&level=ERROR&level=INFO&level=DEBUG';

const ROLLBAR_ENVIRONMENTS: Record<string, string> = {
  Production: 'production',
  Demo: 'demo',
  Sandbox: 'sandbox',
};

const DATADOG_KAFKA_URLS: Record<string, string> = {
  Production:
    'https://app.datadoghq.com/dashboard/pym-r6c-7qm/kafka-consumer-lag?fromUser=false&refresh_mode=sliding&tpl_var_consumer_group_id%5B0%5D=eval-api-worker&live=true',
  Demo: 'https://app.datadoghq.com/dashboard/pym-r6c-7qm/kafka-consumer-lag?fromUser=false&refresh_mode=sliding&tpl_var_consumer_group_id%5B0%5D=eval-api-worker-demo&live=true',
  Sandbox:
    'https://app.datadoghq.com/dashboard/pym-r6c-7qm/kafka-consumer-lag?fromUser=false&refresh_mode=sliding&tpl_var_consumer_group_id%5B0%5D=eval-api-development&live=true',
};

const HEROKU_URLS: Record<string, string> = {
  Production: 'https://dashboard.heroku.com/apps/title-chaining-production',
  Demo: 'https://dashboard.heroku.com/apps/title-chaining-demo',
  Sandbox: 'https://dashboard.heroku.com/apps/title-chaining-sandbox',
};

export const getRollbarUrl = (envLabel: string): string | null => {
  const env = ROLLBAR_ENVIRONMENTS[envLabel];
  return env ? `${ROLLBAR_BASE_URL}&env=${env}` : null;
};

export const getDatadogKafkaUrl = (envLabel: string): string | null => {
  return DATADOG_KAFKA_URLS[envLabel] || null;
};

export const getHerokuUrl = (envLabel: string): string | null => {
  return HEROKU_URLS[envLabel] || null;
};
